export const formatLocationString = (locations: string[] | undefined) => {
  // if "Global" return "All Locations" to match Bee
  if (!locations || locations.length === 0) return 'US'
  if (locations.includes('Global')) return 'All Locations'
  return locations.join(', ')
}
